import api from "./axios";

// `coords` ({ latitude, longitude }) is attached only on the geofence retry —
// most logins send none (see the two-phase flow in LoginPage).
export const login = (username, password, coords) =>
  api.post("/auth/login", {
    username,
    password,
    ...(coords && coords.latitude != null
      ? { latitude: coords.latitude, longitude: coords.longitude }
      : {}),
  });
// Client self-service reset request — the firm's admins are notified in-app.
// Response is always generic (no account enumeration).
export const forgotPassword = (username) =>
  api.post("/auth/forgot-password", { username });
export const changePassword = (current_password, new_password, new_password_confirmation) =>
  api.post("/auth/change-password", {
    current_password,
    new_password,
    new_password_confirmation,
  });
export const logout = (fcm_token) =>
  api.post("/auth/logout", fcm_token ? { fcm_token } : {});
export const logoutAll = () => api.post("/auth/logout-all");
export const me = () => api.get("/auth/me");
export const updateFcmToken = (fcm_token) =>
  api.post("/auth/fcm-token", { fcm_token });
